import { useState } from 'react';
import moment from 'moment';
import usePostCreateOrder from '../../../../queries/usePostCreateOrder';
import { DT0Format } from '../../../../utils/StaticVariable';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';

interface CreateOrderPayload {
  shoppingCartWithSummary: any;
  downloadValues: CheckboxValueType[];
  billingAddress: string;
  showLocation: boolean;
}

export default function useOrderCreation() {
  const [createOrderError, setCreateOrderError] = useState('');
  const [paymentUrl, setPaymentUrl] = useState('');
  const [isOrderSuccessfulModalOpen, setIsOrderSuccessfulModalOpen] = useState(false);
  
  const createOrderMutation = usePostCreateOrder();
  const creatingOrder = createOrderMutation.isPending;

  const resetOrderError = () => {
    setCreateOrderError('');
  };

  const resetPaymentUrl = () => {
    setPaymentUrl('');
  };

  const resetSuccessModal = () => {
    setIsOrderSuccessfulModalOpen(false);
  };

  async function createOrder({
    shoppingCartWithSummary,
    downloadValues,
    billingAddress,
    showLocation
  }: CreateOrderPayload) {
    const data = shoppingCartWithSummary?.data;

    if (!data) return false;

    try {
      const details: string[] = [];
      const orderIds = new Array<string>();
      Object.keys(data.shoppingItems).forEach((pointName: string) => {
        const itemsPerPoint = data.shoppingItems[pointName];
        Object.keys(itemsPerPoint).forEach((category: string) => {
          const item = itemsPerPoint[category];
          orderIds.push(item.order_id);
          const startTime = moment(item.start_date);
          const endTime = moment(item.end_date);
          details.push(
            item.dataset_id +
            '&' +
            startTime.format(DT0Format) +
            '&' +
            endTime.format(DT0Format) +
            '&' +
            item.dataset_category +
            '&' +
            item.location +
            '&' +
            'M' +
            '&' +
            '.csv' +
            '&' +
            '0' +
            '&' +
            item.price +
            '&'
          );
        });
      });

      const detailsPayload = details.join('|');

      const result = await createOrderMutation.mutateAsync({
        shoppingCardDetails: detailsPayload,
        fileFormats: downloadValues.length > 0 ? downloadValues.join('|') : 'csv',
        extractionRequestIds: orderIds,
        billingAddress: billingAddress,
        isDisplayLocation: showLocation
      });

      if (result.paymentUrl) {
        setPaymentUrl(result.paymentUrl);
        return true;
      } else if (result.orderId) {
        setIsOrderSuccessfulModalOpen(true);
        return true;
      }
      return false;
    } catch (error) {
      if (error instanceof Error) {
        setCreateOrderError(error.message || 'We are sorry, we could not create your order.');
      } else {
        setCreateOrderError('We are sorry, we could not create your order.');
      }
      return false;
    }
  }

  return {
    createOrder,
    creatingOrder,
    createOrderError,
    resetOrderError,
    paymentUrl,
    resetPaymentUrl,
    isOrderSuccessfulModalOpen,
    resetSuccessModal
  };
}
